"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncorporationStatus = exports.IncorporationDTO = void 0;
class IncorporationDTO {
    constructor(partial) {
        Object.assign(this, partial);
    }
    static toIncorporationStatus(onboardingStep) {
        switch (onboardingStep) {
            case 1:
                return IncorporationStatus.EN_PROCESO;
            case 2:
                return IncorporationStatus.APROBACION;
            case 3:
                return IncorporationStatus.EMITIDO;
            case 4:
                return IncorporationStatus.RECHAZADO;
            default:
                return IncorporationStatus.NO_CAMBIO;
        }
    }
}
exports.IncorporationDTO = IncorporationDTO;
var IncorporationStatus;
(function (IncorporationStatus) {
    IncorporationStatus["NO_INICIADO"] = "NO INICIADO";
    IncorporationStatus["EN_PROCESO"] = "EN PROCESO";
    IncorporationStatus["RECHAZADO"] = "RECHAZADO";
    IncorporationStatus["APROBACION"] = "APROBACI\u00D3N";
    IncorporationStatus["EMITIDO"] = "EMITIDO";
    IncorporationStatus["NO_CAMBIO"] = "NO CAMBIO";
})(IncorporationStatus || (exports.IncorporationStatus = IncorporationStatus = {}));
//# sourceMappingURL=incorporation-dto.js.map